import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ValueService } from '@app/services';


@Component({
    selector: "participant-count",
    templateUrl: "./participant-count.component.html",
    styleUrls: ["./participant-count.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ParticipantCountComponent implements OnInit {
  constructor(private valueHelper: ValueService) {}

  ngOnInit() {}

  @Input()
  public model: any;

  public get childCount(): number {
    if (this.model) {
      const v = +this.valueHelper.getSafeValue(this.model, 'children');

      return v;
    } else {
      return 0;
    }
  }

  public get adultCount(): number {
    if (this.model) {
      const v = +this.valueHelper.getSafeValue(this.model, 'adults');

      return v;
    } else {
      return 0;
    }
  }
}
